import axios from 'axios';
import config from '../config';
import { getLocalUser } from './localUser';

/*
 * Account-scoped one-time UI flags (guided tour, first-run hint bubbles).
 * Truth lives on the user doc (set via POST /user/ui-flags, read back on
 * every /me); the localStorage `user` mirror makes reads synchronous and
 * writes optimistic, so gating decisions never wait on the network.
 */

const readFlags = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}').ui_flags || {};
  } catch (_e) {
    return {};
  }
};

export const hasUiFlag = (flag) => Boolean(readFlags()[flag]);

export const setUiFlag = (flag) => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    u.ui_flags = { ...(u.ui_flags || {}), [flag]: true };
    localStorage.setItem('user', JSON.stringify(u));
  } catch (_e) { /* private mode - server copy still lands below */ }
  axios.post(
    `${config.API_URL}/user/ui-flags`,
    { flag },
    { headers: getLocalUser() },
  ).catch(() => { /* best effort - the local mirror already gates this tab */ });
};
